import React, { Component } from "react";

import { Mode } from "@formant/core/model/IImageViewConfiguration";

import { Select } from "../../common/Select";

export interface IModeSelectorProps {
    mode: Mode;
    onChange: (mode: Mode) => void;
}

const modes: Mode[] = ["time", "device"];
const label = (_: Mode) => (_ === "time" ? "By time" : "By device");

export class ModeSelector extends Component<IModeSelectorProps> {
    public render() {
        const { mode, onChange } = this.props;

        return (
            <Select
                value={mode}
                options={modes}
                label={label}
                simple={true}
                right={true}
                onChange={onChange}
            />
        );
    }
}
